module.exports = __webpack_public_path__ + "63c5f2eb65daaca870c2b6fc1d8263f7.png";